<template>
  <div class="w-full">
    <div class="flex items-center justify-between mb-2">
      <span class="text-sm font-medium text-foreground">{{ label }}</span>
      <span v-if="showValue" class="text-sm text-muted">{{ value }}%</span>
    </div>
    <div
      class="h-2 w-full rounded-full bg-border-subtle overflow-hidden"
      role="progressbar"
      :aria-valuenow="value"
      aria-valuemin="0"
      aria-valuemax="100"
    >
      <div
        class="h-full rounded-full bg-primary transition-all duration-700 ease-out"
        :style="{ width: `${value}%` }"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'BaseProgress',
  props: {
    label: String,
    value: { type: Number, default: 0, validator: (v) => v >= 0 && v <= 100 },
    showValue: { type: Boolean, default: true },
  },
}
</script>
